import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import type { PermissionUserFormInterface } from 'types';

export const permissionUserFormDefaultValues: PermissionUserFormInterface = {
    firstname: '',
    lastname: '',
    middlename: '',
    email: '',
    phone_number: '',
    role: '',
};

/** Async fn used by Yup to check whether an email is free (e.g. useCheckEmailAvailability). */
export type CheckEmailAvailableFn = (email: string) => Promise<boolean>;

/**
 * Permission user form schema.
 * Pass `checkEmailAvailable` so taken emails fail validation.
 * Pass `currentEmail` on edit so the collaborator's existing address stays valid.
 */
export const permissionUserFormValidationSchema = (
    checkEmailAvailable?: CheckEmailAvailableFn,
    currentEmail?: string
) => {
    const normalizedCurrentEmail = currentEmail?.trim().toLowerCase();
    const emailSchema = checkEmailAvailable
        ? (validateField(ValidationType.EMAIL) as Yup.StringSchema).test(
              'check-email-availability',
              'Email is already in use',
              async (value) => {
                  if (!value) {
                      return true;
                  }
                  if (
                      normalizedCurrentEmail &&
                      value.trim().toLowerCase() === normalizedCurrentEmail
                  ) {
                      return true;
                  }
                  return checkEmailAvailable(value);
              }
          )
        : validateField(ValidationType.EMAIL);

    return Yup.object({
        firstname: validateField(ValidationType.STRING),
        lastname: validateField(ValidationType.STRING),
        middlename: validateField(ValidationType.STRING, false),
        email: emailSchema,
        phone_number: validateField(ValidationType.PHONE, false).nullable(),
        role: validateField(ValidationType.STRING),
    });
};
